<template>
  <el-button type="primary" :disabled="wait_timer > 0"
             v-on:click="sendMessage()" ref="smsBtn" id="smsBtn">
               <span
                 class="num_green"
                 v-show="showNum"
                 v-bind:class="{num:wait_timer>0}"
               >{{this.wait_timer + "s "}}</span>
    <span
      class="span_number"
      v-bind:class="{gray_span:wait_timer>0}"
    >{{ getCodeText() }}</span>
  </el-button>
</template>

<script>
  import {Message} from "element-ui";
    export default {
      name: "smsCode",
      props: {
        mobile: {
          type: String,
          default: ''
        },
        type:{
          type: String,
          default: '1'
        },
        captcha:{
          type:String,
          default:''
        },
        captchaId:{
          type:String,
          default:''
        },
        countryMob: { //手机号-国家区号
          type: String,
        }
      },
      data() {
        return {
          showNum: false,
          wait_timer: false,
        }
      },
      methods: {
        getCodeText: function () {
          if (this.wait_timer > 0) {
            return "已发送";
          }
          if (this.wait_timer === 0) {
            this.showNum = false;
            return "重新发送！";
          }
          if (this.wait_timer === false) {
            return "发送";
          }
        },
        sendMessage: function () {
          if (this.mobile == '') {
            Message.error("请输入手机号");
            return false;
          }if (this.captcha == '') {
            Message.error("请输入图形验证码");
            return false;
          }
          const mob = this.countryMob==='+86' ? this.mobile : this.countryMob + this.mobile;
          let params = {
            type: Number(this.type),
            mobile: mob,
            captcha: this.captcha
          }
          this.postRequestJson('/uacUser/sendSmsCode', params , this.captchaId).then(resp => {
            if (resp.data.code == 1000) {
              this.showNum = true;
              this.wait_timer = 60;
              var that = this;
              var timer_interval = setInterval(function () {
                if (that.wait_timer > 0) {
                  that.wait_timer--;
                } else {
                  clearInterval(timer_interval);
                }
              }, 1000);
            }else {
              console.log(resp);
              Message.error(resp.data.message);
              this.$emit('changeCaptcha')
            }

          })
        },
      }
    }
</script>

<style scoped>

</style>
